import ConfigLoader from '@/helpers/config-loader'
import config from '@/config.js'
import Http from '../helpers/http'
import { omit } from 'lodash'
import { isMoment } from 'moment'

const baseUrl = ConfigLoader.get({ config }).rootUrl

export default {
    findReportingData(seasonId) {
        const query = {}
        if (seasonId) {
            query.FK_Season = seasonId
        }
        return Http.post(baseUrl + '/api/reporting/getReportingData', {
            query
        })
    },
    recreateReportingCache() {
        return Http.post(baseUrl + '/api/reporting/recreateCache')
    },
    findReportsForUser(userId) {
        return Http.post(baseUrl + '/api/report/getReportsForUser')
    },

    createCompany({ entity }) {
        companies.push(entity)
        return Promise.resolve(entity)
    },
    getCompanies() {
        return Http.post(baseUrl + '/api/company/find')
    },
    getEventBaseGroups() {
        return Http.post(baseUrl + '/api/event-group-base/find', {
            lookup: ['additional']
        })
    },
    findArticleTypes() {
        return Http.post(baseUrl + '/api/article-type/find')
    },
    getDashboards() {
        return Http.post(baseUrl + '/api/dashboard/find')
    },
    findOrders() {
        return fetch(orders[2].data, 200)
    },
    findUsers() {
        return Http.post(baseUrl + '/api/user/find')
    },
    findEditableUsers() {
        return Http.post(baseUrl + '/api/user/findEditableUsers')
    },
    createUser(user) {
        return Http.post(baseUrl + '/api/user/createUser', user)
    },
    updateUser(user) {
        // user.company = user.company._id
        return Http.post(baseUrl + '/api/user/update', {
            id: user._id,
            entity: {
                $set: omit(user, ['_id', 'password'])
            }
        })
    },
    removeUser(id) {
        return Http.post(baseUrl + '/api/user/removeUser', { id })
    },
    getOrders(params) {
        return Http.post(baseUrl + '/api/orderhistory/getOrders', params)
    },
    getOrderhistoryFiltersForUser() {
        return Http.post(baseUrl + '/api/orderhistory-filter/getForUser')
    },
    getAllOrderhistoryFilters() {
        return Http.post(baseUrl + '/api/orderhistory-filter/getAll')
    },
    insertOrderhistoryFilter(newFilter) {
        return Http.post(baseUrl + '/api/orderhistory-filter/insert', {
            entity: newFilter
        })
    },
    deleteOrderhistoryFilter(filterId) {
        return Http.post(baseUrl + '/api/orderhistory-filter/remove', { id: filterId }).then(dashboards =>
            dashboards.length > 0 ? dashboards[0] : null
        )
    },
    recreateOrderCache() {
        return Http.post(baseUrl + '/api/orderhistory/recreateCache')
    },
    reloadCompanies() {
        return Http.post(baseUrl + '/api/company/reload')
    },
    markOrderAsPaid({ id }) {
        return Http.post(baseUrl + '/api/order-sql/markOrderAsPaid', {
            id
        })
    },
    saveRequiredLogo(params) {
        return Http.post(baseUrl + '/api/order-sql/saveRequiredLogo', params)
    },
    saveOrderInfo(params) {
        return Http.post(baseUrl + '/api/order-sql/saveOrderInfo', params)
    },
    saveOrderPaymentDate(params) {
        return Http.post(baseUrl + '/api/order-sql/saveOrderPaymentDate', params)
    },
    markOrderAsShipped({ id, ShippingTrackingNumber }) {
        return Http.post(baseUrl + '/api/order-sql/markOrderAsShipped', {
            id,
            ShippingTrackingNumber
        })
    },
    markOrderAsPlacedWithFOHES({ id, FOHESInvoiceNumber, FOHESConfirmationNumber }) {
        return Http.post(baseUrl + '/api/order-sql/markOrderAsPlacedWithFOHES', {
            id,
            FOHESInvoiceNumber,
            FOHESConfirmationNumber
        })
    },
    getOrderAddress(customerId) {
        return Http.post(baseUrl + '/api/customer-sql/get', { id: customerId })
    },
    getOrderArticles(orderId) {
        return Http.post(baseUrl + '/api/order-articles-sql/find', {
            query: {
                FK_Weborder: orderId
            },
            lookup: ['article']
        })
    },
    findSeasons() {
        return Http.post(baseUrl + '/api/season/find')
    },
    getDashboardForUser(userId) {
        return Http.post(baseUrl + '/api/dashboard/find', {
            query: {
                belongsToUser: userId
            }
        }).then(dashboards => (dashboards.length > 0 ? dashboards[0] : null))
    },
    getUserDashboard() {
        return Http.post(baseUrl + '/api/dashboard/getUserDashboard')
    },
    getDashboard(id) {
        return Http.post(baseUrl + '/api/dashboard/get', { id })
    },
    createDashboard(newDashboard) {
        return Http.post(baseUrl + '/api/dashboard/insert', {
            entity: newDashboard
        })
        // .then(dashboards => dashboards.length > 0 ? dashboards[0] : null)
    },
    updateDashboard(dashboard) {
        const id = dashboard._id
        return Http.post(baseUrl + '/api/dashboard/update', {
            id: id,
            entity: { $set: omit(dashboard, ['_id']) }
        })
        // .then(dashboards => dashboards.length > 0 ? dashboards[0] : null)
    },
    deleteDashboardById(id) {
        return Http.post(baseUrl + '/api/dashboard/remove', { id }).then(dashboards =>
            dashboards.length > 0 ? dashboards[0] : null
        )
    },
    getReport(query) {
        return Http.post(baseUrl + '/api/report/find', { query }).then(results =>
            results.length > 0 ? results[0] : null
        )
    },
    getReports() {
        return Http.post(baseUrl + '/api/report/find')
    },
    createReport(newReport) {
        return Http.post(baseUrl + '/api/report/insert', {
            entity: newReport
        })
    },
    updateReport(report) {
        const id = report._id
        return Http.post(baseUrl + '/api/report/update', {
            id: id,
            entity: { $set: omit(report, ['_id']) }
        })
    },
    deleteReportById(id) {
        return Http.post(baseUrl + '/api/report/remove', { id }).then(results =>
            results.length > 0 ? results[0] : null
        )
    },
    saveUserSeason(seasonId) {
        return Http.post(baseUrl + '/api/user/saveSeason', {
            seasonId
        })
    },
    me() {
        return Http.get(baseUrl + '/api/user/me')
    },
    signIn(credentials) {
        return fetch(users, 100).then(users => {
            const user = users.find(u => u.username === credentials.username)
            if (!user) {
                return Promise.reject(new Error('User not found.'))
            }
            if (user.password !== credentials.password) {
                return Promise.reject(new Error('Wrong password.'))
            }
            return Promise.resolve(user)
        })
    },
    updateUserDetailsContact(partnerDetailsContact) {
        return Http.post(baseUrl + '/api/user/setPartnerDetailsContact/', {
            entity: partnerDetailsContact
        })
    },
    updateDefaultPartnerContact(defaultPartnerContact, partnerId, eventId) {
        return Http.post(baseUrl + '/api/event/setPartnerDefaultContact/', {
            entity: defaultPartnerContact,
            partnerId: partnerId,
            eventId: eventId
        })
    },
    getGuestDetailsEvents(params) {
        return Http.post(baseUrl + '/api/event/getEvents', {
            query: {
                companyId: params.companyId,
                seasonId: params.seasonId
            }
        })
    },
    getGuestDetailsEvent(id) {
        return Http.post(baseUrl + '/api/event/find', {
            query: {
                _id: id
            }
        })
    },
    getTicketRequests() {
        return Http.post(baseUrl + '/api/ticket-request/getRequests', {
           
        })
    },
    getEventGuests(params) {
        return Http.post(baseUrl + '/api/guest-registration/getGuests', params)
    },
    downloadExcel(params) {
        return Http.post(baseUrl + '/api/event/downloadExcel', params, { responseType: 'blob' })
    },
    downloadExcelForPartner(params) {
        return Http.post(baseUrl + '/api/event/downloadExcelForPartner', params, { responseType: 'blob' })
    },
    reloadEvents() {
        return Http.post(baseUrl + '/api/event/recreateEventData')
    },
    reloadGuests() {
        return Http.post(baseUrl + '/api/guest-registration/recreateGuestData')
    },
    reloadTicketRequests() {
        return Http.post(baseUrl + '/api/ticket-request/recreateTicketRequests')
    },
    updateMarkBooked(params) {
        return Http.post(baseUrl + '/api/ticket-request/updateMarkBooked', params), {
                id: params._id
        }
    },
    updateMarkOffered(params) {
        return Http.post(baseUrl + '/api/ticket-request/updateMarkOffered', params), {
                id: params._id
        }
    },
    updateMarkRejected(params) {
        return Http.post(baseUrl + '/api/ticket-request/updateMarkRejected', params), {
                id: params._id
        }
    },
    updateMarkBookedSQ1L({ id }) {
        return Http.post(baseUrl + '/api/request-sql/updateMarkBookedSQL', {
            id
        })
    },
    getContractualContingent() {
        return Http.get(baseUrl + '/api/partner/getContractualContingent');
    },
    getContractualContingentByEvent() {
        return Http.get(baseUrl + '/api/partner-event-contingent/getContractualContingentByEvent');
    },
    getEventGroupTargetSales() {
        return Http.post(baseUrl + '/api/event-group-targetsales/getEventGroupTargetSales', { query: {} });
    }
}